import { Form, Select } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import CreateDrawer from "../CRM/CommonUi/CreateDrawer";
import TableComponent from "../CRM/CommonUi/TableComponent";
import CreateBookingForm from "./CreateBookingForm";
import { getAllBookings } from "../../redux/rtk/features/crm/booking/bookingSlice";

const columns = [
	{
		title: "Franchise Name",
		width: 150,
		key: "franchiseName",
		dataIndex: "franchiseName",
		render: (franchiseName) => franchiseName || "-",
	},
	{
		title: "Game Room",
		width: 150,
		key: "gameName",
		dataIndex: "gameName",
		render: (gameName) => gameName || "-",
	},
	{
		title: "Customer Name",
		width: 150,
		key: "name",
		dataIndex: "name",
		render: (name) => name || "-",
	},
	{
		title: "Booking Date",
		width: 150,
		key: "bookingDate",
		dataIndex: "bookingDate",
		render: (date) => moment(date).format("MMMM Do YYYY"),
		sorter: (a, b) => new Date(a.bookingDate) - new Date(b.bookingDate),
	},
	{
		title: "Time Slot",
		key: "slotTime",
		dataIndex: "slotTime",
		width: 150,
		render: (slotTime) => slotTime || "-",
	},
	{
		title: "Phone No",
		width: 150,
		key: "contact",
		dataIndex: "contact",
		render: (contact) => contact || '-'
	},
	{
		title: "Participants",
		width: 150,
		key: "numberOfParticipants",
		dataIndex: "numberOfParticipants",
		render: (numberOfParticipants) => numberOfParticipants || '-'
	},
	{
		title: "Amount",
		width: 150,
		key: "finalAmount",
		dataIndex: "finalAmount",
		render: (finalAmount) => finalAmount || '-'
	},
	{
		title: "Transaction Code",
		width: 150,
		key: "transactionCode",
		dataIndex: "transactionCode",
		render: (transactionCode) => transactionCode || '-'
	},
	{
		title: "Payment Method",
		width: 150,
		key: "paymentGateway",
		dataIndex: "paymentGateway",
		render: (paymentGateway) => paymentGateway || '-'
	},
	{
		title: "Status",
		width: 150,
		key: "status",
		dataIndex: "status",
		render: (status) => <p className={status=='Success' ? 'text-green-500' : 'text-red-500' }> {status || '-'}</p>
	},
	{
		title: "Payment Status",
		width: 150,
		key: "paymentStatus",
		dataIndex: "paymentStatus",
		render: (paymentStatus) => <p className={paymentStatus=='Success' ? 'text-green-500' : 'text-red-500' }> {paymentStatus || '-'}</p>
	}
];

const Quotes = () => {

	const dispatch = useDispatch();

	const { isFetchingAll, isSubmitting, list } = useSelector((state) => state.booking);
	const [filteredList, setFilteredList] = useState(list);
	useEffect(() => {
		setFilteredList(list)
	}, [list])
	// Drawer state
	const [open, setOpen] = useState(false);
	const onClose = () => {
		setOpen(false);
	};

	// filter
	const [isFilter, setFilter] = useState(false);
	const filterToggle = () => {
		setFilter((prev) => !prev);
	};

	useEffect(() => {
		dispatch(getAllBookings({ status: true }));
	}, [dispatch]);
	// Basic Search 
	function handleSearch(value) {
		if (value === "") {
			setFilteredList(list)
		} else {
			const filteredBookings = list.filter((booking) => {
				return booking?.user?.franchiseName?.toLowerCase().includes(value.toLowerCase()) || booking?.product?.gameName?.toLowerCase().includes(value.toLowerCase()) || booking?.name?.toLowerCase().includes(value.toLowerCase())
			})
			setFilteredList(filteredBookings)
		}
	}

	return (
		<div className='px-4'>
			<div className='bg-white dark:bg-DTableBg flex justify-between items-center gap-3 filter-wrapper border-radius-top table-top-padding'>
				<div className="flex items-center">
					<h2 className="text-xl lg:text-2xl font-semibold">Booking List</h2>
				</div>
				<div className="flex flex-col sm:flex-row sm:items-center sm:gap-[12px]">
					{/*<div className='flex flex-col sm:flex-row sm:justify-end sm:items-center gap-5'>
						<button
							onClick={filterToggle}
							className={`hidden md:block ${isFilter ? "btn-secondary rounded-[1.25rem]" : "rounded-[1.25rem]"
								}  px-5 py-2 cursor-pointer rounded-[1.25rem] btn-secondary`}
							type='submit'>
							{isFilter ? (
								<span className='flex justify-center items-center gap-2'>
									<AiOutlineClose /> Close
								</span>
							) : (
								<span className=''>Filter</span>
							)}
						</button>
						 {!isFilter ? (
							<CrmSearch paginatedThunk={loadAllQuotePaginated} />
						) : (
							<div className='flex flex-col sm:flex-row text-md'>
								<Form
									className='flex flex-wrap justify-center gap-2 md:items-center'
									form={form}
									onFinish={onFinish}
									onFinishFailed={onFinishFailed}
									layout='inline'
									initialValues={{
										status: ["true"],
									}}>
									<Form.Item name='quoteOwner' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Owner'
											maxTagCount={0}
											maxTagPlaceholder={<div className='w-[150px]'>Owner</div>}>
											{quoteOwner?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item?.firstName} {item?.lastName}
												</Option>
											))}
										</Select>
									</Form.Item>

									<Form.Item name='quoteStage' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Stage'
											maxTagCount={0}
											maxTagPlaceholder={<div className='w-[150px]'>Stage</div>}>
											{quoteStage?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.quoteStageName}
												</Option>
											))}
										</Select>
									</Form.Item>

									<Form.Item name='contact' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select contact'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Contact</div>
											}>
											{contact?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item?.firstName} {item?.lastName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='company' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Company'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Company</div>
											}>
											{company?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.companyName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='opportunity' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Select Opportunity'
											maxTagCount={0}
											maxTagPlaceholder={
												<div className='w-[150px]'>Opportunity</div>
											}>
											{opportunity?.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.opportunityName}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Form.Item name='status' className='w-full md:w-[180px]'>
										<Select
											mode='multiple'
											style={{ width: "100%" }}
											placeholder='Please select'
											defaultValue={["true"]}>
											<Option value='true'>True</Option>
											<Option value='false'>False</Option>
										</Select>
									</Form.Item>
									<Form.Item>
										<div className='w-full md:w-[180px] flex justify-start'>
											<button
												className='custom-filter-btn text-white px-5 py-2 rounded cursor-pointer'
												type='submit'>
												Filter
											</button>
											<button
												onClick={filterToggle}
												className='block md:hidden  px-5 py-2 rounded cursor-pointer ml-2 text-rose-700 transition-colors duration-150 border border-rose-500 focus:shadow-outline hover:bg-rose-500 hover:text-rose-100'>
												Cancel
											</button>
										</div>
									</Form.Item>
								</Form>
							</div>
						)}
					</div> */}
					{!isFilter && (
						<UserPrivateComponent permission='create-quote'>
							<button
								onClick={() => setOpen(true)}
								className='py-2 px-3 md:px-6 btn-primary cursor-pointer flex items-center gap-2 w-max text-[10px] md:text-[14px]'>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="plus-icon">
									<path stroke="white" fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
								</svg>
								<span className="text-white text-[10px] md:text-[14px] font-semibold">Create Booking</span>
							</button>
						</UserPrivateComponent>
					)}
				</div>
			</div>
			<UserPrivateComponent permission='readAll-quote'>
				<TableComponent
					list={filteredList}
					csvList={filteredList.map(({ product, user, slots, ...rest }) => ({ ...rest, gameName: product?.gameName, franchiseName: user?.franchiseName, slotName: slots?.slotName }))}
					loading={isFetchingAll}
					columns={columns}
					csvFileName={"Booking-List"}
					handleSearch={handleSearch}
				/>
			</UserPrivateComponent>

			<UserPrivateComponent permission='create-quote'>
				<CreateDrawer onClose={onClose} open={open} title={"Create New Booking"}>
					<CreateBookingForm onClose={onClose} open={open} />
				</CreateDrawer>
			</UserPrivateComponent>
		</div>
	);
};
export default Quotes;
